(function () {
    'use strict';
    const el = id => document.getElementById(id);
    if (!el('cc-config')) return;
    const cfg = JSON.parse(el('cc-config').textContent);
    const root = (cfg.root || '/').replace(/\/?$/, '/');
    const variants = new Map(cfg.variants.map(v => [String(v.id), v]));
    const grid = el('ccGrid'), bar = el('ccBar'), buyBtn = el('ccBuy');
    const details = el('ccDetails'), sheet = el('ccSheet'), bag = el('ccBag');
    const guide = el('ccGuide'), guideOptions = el('ccGuideOptions');
    const viewer = el('ccViewer'), matcher = el('ccMatcher'), reviewDialog = el('ccReviewDialog');
    let reviewScroll = null;
    const dialogTriggers = new WeakMap(), skipDialogReturn = new WeakSet();
    const cards = [...grid.querySelectorAll('.cc-card[data-id]')];
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const wideGrid = window.matchMedia('(min-width: 600px)');
    // Editorial assortments: every shade belongs to four sets; no pair appears more than twice.
    const wardrobeSets = [
        ["black", "green", "kesar-ochre", "peacock-teal"],
        ["black", "mint-green", "surkhi-clay", "pink"],
        ["black", "maroon", "turquoise-blue", "dusty-rose"],
        ["black", "white", "neem-sage", "deep-plum"],
        ["white", "bottle-green", "red", "kesar-ochre"],
        ["white", "deep-plum", "yellow", "neem-sage"],
        ["white", "peacock-teal", "pink", "surkhi-clay"],
        ["chiko", "navy", "pink", "green"],
        ["chiko", "cocoa-brown", "maroon", "yellow"],
        ["navy", "neem-sage", "red", "kesar-ochre"],
        ["navy", "mint-green", "deep-plum", "surkhi-clay"],
        ["navy", "turquoise-blue", "bottle-green", "dusty-rose"],
        ["cocoa-brown", "neem-sage", "peacock-teal", "pink"],
        ["cocoa-brown", "dusty-rose", "bottle-green", "yellow"],
        ["cocoa-brown", "mint-green", "turquoise-blue", "kesar-ochre"],
        ["chiko", "maroon", "green", "yellow"],
        ["chiko", "deep-plum", "red", "mint-green"],
        ["maroon", "peacock-teal", "dusty-rose", "green"],
        ["bottle-green", "surkhi-clay", "turquoise-blue", "red"]
    ];
    const wardrobeNotes = {
        "black": "Deep contrast for light or printed kurtis.",
        "white": "Light contrast for dark or bright kurtis.",
        "chiko": "Warm tan for cream or earthy kurtis.",
        "navy": "A softer dark option for light kurtis.",
        "cocoa-brown": "Deep brown for cream or earthy kurtis.",
        "maroon": "Rich colour for cream or soft prints.",
        "neem-sage": "Soft green for cream or muted prints.",
        "dusty-rose": "Soft rose for cream or muted prints.",
        "bottle-green": "Deep green for cream or warm prints.",
        "peacock-teal": "Deep teal for light or warm shades.",
        "kesar-ochre": "Warm colour for dark or earthy kurtis.",
        "surkhi-clay": "Warm rust for cream or earthy kurtis.",
        "deep-plum": "Deep purple for light or soft shades.",
        "turquoise-blue": "Bright blue for light kurtis or matching prints.",
        "mint-green": "Bright green for cream or matching prints.",
        "red": "Bright colour for cream or matching prints.",
        "pink": "Bright colour for cream or matching prints.",
        "yellow": "Warm colour for dark kurtis or matching prints.",
        "green": "Rich green for cream or matching prints."
    };
    const families = {
        "classic": {
            "name": "Classic neutrals",
            "colours": [
                "black",
                "white",
                "chiko",
                "navy",
                "cocoa-brown"
            ]
        },
        "soft": {
            "name": "Soft shades",
            "colours": [
                "neem-sage",
                "dusty-rose",
                "chiko"
            ]
        },
        "rich": {
            "name": "Rich shades",
            "colours": [
                "maroon",
                "bottle-green",
                "peacock-teal",
                "deep-plum",
                "kesar-ochre",
                "surkhi-clay",
                "turquoise-blue",
                "mint-green",
                "red",
                "pink",
                "yellow",
                "green",
                "navy"
            ]
        }
    };
    const colourLooks = {
        "black": [
            "Classic neutral",
            "Dark neutral"
        ],
        "white": [
            "Classic neutral",
            "Light neutral"
        ],
        "chiko": [
            "Classic neutral",
            "Warm neutral"
        ],
        "navy": [
            "Classic neutral",
            "Deep blue"
        ],
        "cocoa-brown": [
            "Classic neutral",
            "Warm brown"
        ],
        "neem-sage": [
            "Soft shade",
            "Muted green"
        ],
        "dusty-rose": [
            "Soft shade",
            "Muted rose"
        ],
        "maroon": [
            "Rich shade",
            "Deep red"
        ],
        "bottle-green": [
            "Rich shade",
            "Deep green"
        ],
        "peacock-teal": [
            "Rich shade",
            "Deep teal"
        ],
        "deep-plum": [
            "Rich shade",
            "Deep purple"
        ],
        "kesar-ochre": [
            "Rich shade",
            "Golden ochre"
        ],
        "surkhi-clay": [
            "Rich shade",
            "Warm rust"
        ],
        "turquoise-blue": [
            "Rich shade",
            "Bright turquoise"
        ],
        "mint-green": [
            "Rich shade",
            "Fresh green"
        ],
        "red": [
            "Rich shade",
            "Bright red"
        ],
        "pink": [
            "Rich shade",
            "Bright pink"
        ],
        "yellow": [
            "Rich shade",
            "Bright yellow"
        ],
        "green": [
            "Rich shade",
            "Vibrant green"
        ]
    };
    const kurtaColours = {
        "light": {
            "label": "White / cream",
            "colour": "#f0e9da",
            "choices": [
                "maroon",
                "navy",
                "bottle-green",
                "deep-plum",
                "cocoa-brown",
                "black"
            ]
        },
        "dark": {
            "label": "Black / grey",
            "colour": "#474443",
            "choices": [
                "white",
                "chiko",
                "dusty-rose",
                "neem-sage"
            ]
        },
        "blue": {
            "label": "Blue",
            "colour": "#638aae",
            "choices": [
                "white",
                "chiko",
                "navy",
                "maroon"
            ]
        },
        "green": {
            "label": "Green",
            "colour": "#78966f",
            "choices": [
                "chiko",
                "white",
                "cocoa-brown",
                "black"
            ]
        },
        "pink": {
            "label": "Pink",
            "colour": "#cc929f",
            "choices": [
                "white",
                "chiko",
                "navy",
                "cocoa-brown"
            ]
        },
        "purple": {
            "label": "Purple",
            "colour": "#8a7296",
            "choices": [
                "chiko",
                "white",
                "black",
                "navy"
            ]
        },
        "warm": {
            "label": "Red / orange",
            "colour": "#c96c50",
            "choices": [
                "chiko",
                "white",
                "navy",
                "cocoa-brown"
            ]
        },
        "yellow": {
            "label": "Yellow",
            "colour": "#d8b95a",
            "choices": [
                "navy",
                "white",
                "maroon",
                "bottle-green"
            ]
        }
    };
    let guidance = null, guideKey = '', guideMove = 0;
    let family = 'all', matchDraft = [], matchContext = [], viewerId = null;
    const pendingKey = 'cottonsalwar:catalogue-add-pending';
    let picked = {}, cart = null, busy = false, uncertain = false;
    try { uncertain = sessionStorage.getItem(pendingKey) === '1'; } catch (_) {}
    const hadPendingAdd = uncertain;
    const money = amount => '₹' + (amount / 100).toLocaleString('en-IN', { maximumFractionDigits: 2 });
    const qty = items => Object.values(items).reduce((n, q) => n + q, 0);
    const cartCounts = value => (value?.items || []).reduce((out, item) => {
        const id = String(item.variant_id || item.id);
        out[id] = (out[id] || 0) + item.quantity;
        return out;
    }, {});
    const catalogueQty = value => Object.entries(cartCounts(value)).reduce((n, [id, q]) => n + (variants.has(id) ? q : 0), 0);
    const total = () => qty(picked) + catalogueQty(cart);
    const signature = value => JSON.stringify({
        items: (value?.items || []).map(i => [i.key || String(i.variant_id || i.id), i.quantity, i.final_line_price]).sort(),
        total: value?.total_price, currency: value?.currency
    });
    function track(name, data) {
        try { window.clarity?.('event', name); if (data) window.clarity?.('set', 'cc_' + name, String(data)); } catch (_) {}
    }
    function pending(value) {
        uncertain = value;
        try { if (value) sessionStorage.setItem(pendingKey, '1'); else sessionStorage.removeItem(pendingKey); } catch (_) {}
    }
    function available(id) {
        const v = variants.get(id);
        if (!v?.available) return 0;
        return Math.max(0, Math.min(5, v.maxQty == null ? 5 : v.maxQty - (cartCounts(cart)[id] || 0)));
    }
    function feedback(message, urgent = false) {
        el('ccFeedback').textContent = message;
        el('ccFeedback').hidden = !message;
        el('ccBarStatus').textContent = urgent ? message : '';
        el('ccBarStatus').hidden = !urgent;
    }
    function estimate(count) {
        return count * (cfg.price - (count >= 2 ? cfg.perItemDisc : 0)) + (count >= cfg.freeShipQty ? 0 : cfg.standardShip);
    }
    function paint() {
        variants.forEach((v, id) => {
            const card = grid.querySelector('[data-id="' + id + '"]');
            if (!card) return;
            const count = picked[id] || 0;
            card.classList.toggle('is-picked', count > 0);
            card.querySelector('[data-select]').setAttribute('aria-pressed', String(count > 0));
            card.querySelector('[data-select]').setAttribute('aria-label', (count ? 'Selected, remove ' : v.available ? 'Select ' : 'Notify me about ') + v.name);
            card.querySelector('[data-select-label]').textContent = count ? 'Selected ✓' : v.available ? 'Select +' : 'Notify me';
            card.querySelector('.cc-tick').textContent = count > 1 ? String(count) : '✓';
            card.querySelector('.cc-qty').hidden = count === 0;
            card.querySelector('.cc-qty b').textContent = count;
            card.querySelector('[data-inc]').disabled = busy || count >= available(id);
            card.querySelector('[data-dec]').disabled = busy;
            card.querySelector('[data-select]').disabled = busy;
        });
    }
    function guideEligible() {
        return cfg.guidedSecond !== false && guidance && !uncertain && !cart?.items.length && qty(picked) > 0 && qty(picked) <= 4;
    }
    function placeGuide() {
        if (!guidance) return;
        const visible = cards.filter(card => !card.hidden);
        const index = visible.findIndex(card => card.dataset.id === guidance.position);
        const columns = wideGrid.matches ? 3 : 2;
        const end = Math.min(visible.length - 1, Math.floor(Math.max(0, index) / columns) * columns + columns - 1);
        if (!visible.length) grid.prepend(guide);
        else if (visible[end]?.nextElementSibling !== guide) visible[end]?.after(guide);
    }
    function guidePhoto(id) {
        const original = cards.find(card => card.dataset.id === id)?.querySelector('.cc-img img');
        const img = original ? original.cloneNode() : document.createElement('img');
        if (!original) img.src = variants.get(id).img;
        img.loading = 'eager'; img.alt = ''; img.removeAttribute('id');
        img.sizes = '(max-width: 599px) 45vw, 300px';
        return img;
    }
    function element(tag, className, text) {
        const node = document.createElement(tag);
        if (className) node.className = className;
        if (text) node.textContent = text;
        return node;
    }
    function familyContains(key, slug) {
        return key === 'all' || families[key]?.colours.includes(slug);
    }
    function applyFamily(key, dismiss = true) {
        family = families[key] && cfg.colourFamilies !== false ? key : 'all';
        el('ccFamilies').querySelectorAll('[data-family]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.family === family)));
        cards.forEach(card => { card.hidden = !familyContains(family, card.dataset.slug); });
        grid.querySelector('.cc-custom').hidden = family !== 'all';
        if (dismiss && guidance) { guidance.dismissed = true; guideMove++; }
        el('ccFamilyStatus').textContent = family === 'all' ? 'Showing all ' + cards.length + ' colours.' : cards.filter(card => !card.hidden).length + ' ' + families[family].name.toLowerCase() + ' shown. Your selections are kept.';
        render();
    }
    el('ccFamilies').addEventListener('click', e => {
        const button = e.target.closest('[data-family]');
        if (!button || busy) return;
        matchContext = [];
        applyFamily(button.dataset.family); track('cc_family', family);
    });
    function matchChoices(context, exclude = '', limit = 2) {
        return cfg.variants.map(v => {
            const matched = context.filter(key => kurtaColours[key]?.choices.includes(v.slug));
            const rank = matched.reduce((sum, key) => sum + kurtaColours[key].choices.indexOf(v.slug), 0);
            return { ...v, matched, rank, styleReason: 'Try with ' + matched.map(key => kurtaColours[key].label.toLowerCase()).join(' or ') + '.' };
        }).filter(v => v.matched.length && String(v.id) !== exclude && available(String(v.id)) > 0)
            .sort((a, b) => b.matched.length - a.matched.length || a.rank - b.rank)
            .slice(0, limit);
    }
    const wardrobeSeedKey = 'cottonsalwar:wardrobe-v2';
    function readWardrobeSeed() {
        try {
            const saved = sessionStorage.getItem(wardrobeSeedKey);
            if (saved !== null && /^\d+$/.test(saved) && Number(saved) <= 0xffffffff) return Number(saved);
        } catch (_) {}
        const seed = window.crypto?.getRandomValues ? window.crypto.getRandomValues(new Uint32Array(1))[0] : Math.floor(Math.random() * 0x100000000);
        try { sessionStorage.setItem(wardrobeSeedKey, String(seed)); } catch (_) {}
        return seed;
    }
    const wardrobeSeed = readWardrobeSeed();
    function wardrobeHash(key) {
        let hash = 2166136261;
        for (const char of String(wardrobeSeed) + '|' + key) hash = Math.imul(hash ^ char.charCodeAt(0), 16777619);
        hash ^= hash >>> 16; hash = Math.imul(hash, 0x7feb352d);
        hash ^= hash >>> 15; hash = Math.imul(hash, 0x846ca68b);
        return (hash ^ (hash >>> 16)) >>> 0;
    }
    function orderedWardrobeSets(slug) {
        const sets = wardrobeSets.filter(set => set.includes(slug));
        if (!sets.length) return [];
        const start = wardrobeHash(slug + '|set') % sets.length;
        return [...sets.slice(start), ...sets.slice(0, start)].map(set => {
            const others = set.filter(colour => colour !== slug);
            const position = wardrobeHash(slug + '|position|' + set.join(',')) % others.length;
            return [...others.slice(position), ...others.slice(0, position)];
        });
    }
    function suggestedColours(id) {
        if (matchContext.length) return matchChoices(matchContext, id, 3);
        const groups = orderedWardrobeSets(variants.get(id).slug);
        const eligible = slug => {
            const v = cfg.variants.find(item => item.slug === slug);
            return v && String(v.id) !== id && available(String(v.id)) > 0;
        };
        let pool;
        if (family !== 'all') {
            // Respect a deliberate family preference, including small families with fewer than three choices.
            pool = [...new Set([...groups.flat().filter(slug => familyContains(family, slug)), ...families[family].colours])].filter(eligible);
        } else {
            const availableGroups = groups.map(set => set.filter(eligible));
            // Prefer a complete approved set. Combine available alternatives only if every set has gaps.
            pool = availableGroups.find(set => set.length === 3)
                || [...new Set(availableGroups.sort((a, b) => b.length - a.length).flat())];
        }
        return pool.slice(0, 3).map(slug => {
            const v = cfg.variants.find(item => item.slug === slug);
            return { ...v, styleReason: wardrobeNotes[v.slug] || '' };
        });
    }
    function colourChoice(v, source = 'guide') {
        const id = String(v.id), item = element('button', 'cc-guide-option');
        item.type = 'button';
        item.dataset[source === 'match' ? 'matchPick' : 'guidePick'] = id;
        const selected = source === 'guide' && picked[id] > 0;
        item.setAttribute('aria-label', source === 'match' ? 'Choose ' + v.name + ' as your ' + (!qty(picked) ? 'first' : 'second') + ' colour' : (selected ? 'Remove ' : 'Add ') + v.name + (selected ? ' from selection' : ' to selection'));
        if (source === 'guide') item.setAttribute('aria-pressed', String(selected));
        const image = element('span', 'cc-guide-image'); image.append(guidePhoto(id));
        const caption = element('span', 'cc-guide-caption');
        caption.append(element('strong', '', v.name));
        if (v.styleReason) {
            const reason = element('small', 'cc-colour-reason', v.styleReason);
            reason.id = 'cc-' + source + '-reason-' + id;
            item.setAttribute('aria-describedby', reason.id); caption.append(reason);
        }
        caption.append(element('span', 'cc-guide-add', source === 'match' ? 'Choose ' + v.name : selected ? '✓ Added · Remove' : 'Add ' + v.name));
        if (selected) image.append(element('span', 'cc-guide-selected-mark', '✓'));
        item.append(image, caption);
        return item;
    }
    function matchEligible() {
        return cfg.kurtaMatching !== false && qty(picked) < 2 && !cart?.items.length && !uncertain;
    }
    function renderMatchQuestion() {
        el('ccMatchQuestion').hidden = false; el('ccMatchResults').hidden = true;
        el('ccMatchShow').hidden = false; el('ccMatchShow').disabled = !matchDraft.length || busy;
        el('ccKurtaChoices').querySelectorAll('[data-kurta]').forEach(button => {
            const selected = matchDraft.includes(button.dataset.kurta);
            button.setAttribute('aria-pressed', String(selected));
            button.disabled = busy || (!selected && matchDraft.length >= 3);
        });
        el('ccMatchStatus').textContent = matchDraft.length === 3 ? '3 chosen. Tap a chosen colour to change it.' : '';
    }
    function renderMatchResults() {
        const choices = matchChoices(matchDraft, Object.keys(picked)[0]);
        el('ccMatchQuestion').hidden = true; el('ccMatchResults').hidden = false; el('ccMatchShow').hidden = true;
        el('ccMatchSummary').textContent = matchDraft.map(key => kurtaColours[key].label).join(' · ');
        el('ccMatchHeading').textContent = choices.length === 2 ? 'Two colours to consider' : choices.length ? 'A colour to consider' : 'No suggested shades available';
        el('ccMatchIntro').textContent = choices.length ? 'Choose the look you like.' : 'Our suggested shades are unavailable. You can still browse the full range.';
        el('ccMatchOptions').replaceChildren(...choices.map(v => colourChoice(v, 'match')));
        el('ccMatchOptions').dataset.count = String(choices.length);
    }
    function openMatcher() {
        if (!matchEligible() || busy) return;
        const trigger = viewer.open ? dialogTriggers.get(viewer) : document.activeElement;
        if (viewer.open) closeDialog(viewer, false);
        matchDraft = [...matchContext]; renderMatchQuestion(); openDialog(matcher, trigger);
        track('cc_match_open');
    }
    el('ccMatchShow').addEventListener('click', () => {
        if (!matchDraft.length || !matchEligible() || busy) return;
        renderMatchResults(); el('ccMatchHeading').focus({ preventScroll: true });
        el('ccMatchResults').closest('.cc-sheet-body').scrollTop = 0;
        track('cc_match_results', matchDraft.length);
    });
    el('ccMatchChange').addEventListener('click', () => {
        renderMatchQuestion(); el('ccKurtaChoices').querySelector('[aria-pressed="true"]')?.focus();
    });
    matcher.addEventListener('click', e => {
        const answer = e.target.closest('[data-kurta]'), choice = e.target.closest('[data-match-pick]');
        if (answer && !busy) {
            const key = answer.dataset.kurta;
            if (matchDraft.includes(key)) matchDraft = matchDraft.filter(value => value !== key);
            else if (matchDraft.length < 3) matchDraft.push(key);
            renderMatchQuestion();
        } else if (choice && matchEligible() && !busy) {
            const id = choice.dataset.matchPick;
            if (!available(id) || picked[id]) return;
            matchContext = [...matchDraft];
            applyFamily('all', false);
            if (guidance) guidance.dismissed = false;
            closeDialog(matcher, false); setQty(id, 1, 'kurta_match'); finishDialogSelection(id);
            track('cc_match_pick', variants.get(id).slug);
        }
    });
    function finishDialogSelection(id) {
        if (guideEligible() && !guidance.dismissed) revealGuide();
        else requestAnimationFrame(() => {
            const target = buyBtn.hidden ? cards.find(card => card.dataset.id === id)?.querySelector('[data-select]') : buyBtn;
            target?.focus({ preventScroll: true });
            if (buyBtn.hidden) target?.scrollIntoView({ block: 'center', behavior: reduceMotion.matches ? 'instant' : 'smooth' });
        });
    }
    function renderViewer() {
        if (!viewerId) return;
        const v = variants.get(viewerId), selected = picked[viewerId] > 0;
        el('ccViewerSelect').textContent = selected ? v.name + ' selected' : available(viewerId) ? 'Choose ' + v.name : v.name + ' unavailable';
        el('ccViewerSelect').disabled = busy || selected || !available(viewerId);
    }
    function openViewer(id, trigger) {
        viewerId = id;
        const v = variants.get(id), img = el('ccViewerImage');
        el('ccViewerTitle').textContent = v.name;
        el('ccViewerFamily').textContent = colourLooks[v.slug]?.[0] || '';
        el('ccPhotoStage').classList.remove('is-zoomed');
        el('ccPhotoStage').scrollTop = el('ccPhotoStage').scrollLeft = 0;
        el('ccPhotoToggle').setAttribute('aria-pressed', 'false'); el('ccPhotoToggle').textContent = 'Zoom in';
        el('ccPhotoStatus').textContent = 'Loading photo…';
        img.alt = v.name + ' cotton salwar pant, enlarged'; img.src = v.imgLarge || v.img;
        renderViewer(); openDialog(viewer, trigger); track('cc_photo_open', v.slug);
    }
    el('ccViewerImage').addEventListener('load', () => { el('ccPhotoStatus').textContent = ''; });
    el('ccViewerImage').addEventListener('error', () => { el('ccPhotoStatus').textContent = 'Photo could not load. Close and try again.'; });
    el('ccPhotoToggle').addEventListener('click', () => {
        const zoom = el('ccPhotoStage').classList.toggle('is-zoomed');
        el('ccPhotoToggle').setAttribute('aria-pressed', String(zoom)); el('ccPhotoToggle').textContent = zoom ? 'Zoom out' : 'Zoom in';
        el('ccPhotoStage').scrollTop = el('ccPhotoStage').scrollLeft = 0;
        el('ccPhotoStage').setAttribute('aria-label', zoom ? 'Enlarged garment photo. Scroll to see more detail.' : 'Enlarged garment photo');
    });
    el('ccViewerSelect').addEventListener('click', () => {
        const id = viewerId;
        if (busy || picked[id] || !available(id)) return;
        closeDialog(viewer, false); setQty(id, 1, 'photo'); finishDialogSelection(id);
    });
    el('ccViewerFit').addEventListener('click', () => {
        const trigger = dialogTriggers.get(viewer); closeDialog(viewer, false);
        el('ccDetailsTitle').textContent = 'Size & fit'; el('ccDetailsBody').innerHTML = el('ccFitSpecs').innerHTML;
        openDialog(details, trigger);
    });
    function wardrobeSuggestions(first) {
        const context = JSON.stringify([first, family, matchContext]);
        if (guidance.context !== context) {
            guidance.context = context;
            guidance.options = suggestedColours(first);
        }
        // Keep the original recommendations in place after a selection. Replace only unavailable choices.
        const kept = guidance.options.filter(v => available(String(v.id)) > 0);
        if (kept.length < 3) {
            suggestedColours(first).forEach(v => { if (kept.length < 3 && !kept.some(item => item.id === v.id)) kept.push(v); });
        }
        guidance.options = kept;
        return kept;
    }
    function renderReview(count) {
        const review = cfg.reviews?.product, slot = el('ccReview');
        const quote = typeof review?.quote === 'string' ? review.quote.trim() : '';
        const full = typeof review?.full === 'string' ? review.full.trim() : '';
        const valid = quote && (!full || full.includes(quote));
        slot.hidden = count < 2 || !valid;
        el('ccReviewText').textContent = valid ? '“' + quote + '”' : '';
        el('ccReviewMore').hidden = !el('reviews');
    }
    el('ccReviewMore').addEventListener('click', () => {
        const source = el('reviews')?.querySelector('.reviews-inner');
        if (!source || reviewDialog.open) return;
        const messages = source.querySelector('.reviews-grid').cloneNode(true);
        const more = source.querySelector('.reviews-more')?.cloneNode(true);
        if (more) more.open = false;
        el('ccReviewMessages').replaceChildren(messages, ...(more ? [more] : []));
        const body = document.body;
        reviewScroll = { x: window.scrollX, y: window.scrollY, overflow: body.style.overflow,
            rootOverflow: document.documentElement.style.overflow,
            styles: Object.fromEntries(['position', 'top', 'left', 'right', 'width'].map(key => [key, body.style[key]])) };
        Object.assign(body.style, { position: 'fixed', top: -reviewScroll.y + 'px', left: -reviewScroll.x + 'px', right: '0', width: '100%' });
        document.documentElement.style.overflow = 'hidden';
        openDialog(reviewDialog, el('ccReviewMore'));
        el('ccReviewBody').scrollTop = 0;
        track('cc_review_open', 'product');
    });
    const recommendationViews = new Set();
    const recommendationObserver = typeof IntersectionObserver === 'undefined' ? null : new IntersectionObserver(entries => {
        entries.forEach(entry => {
            const card = entry.target;
            if (!entry.isIntersecting || entry.intersectionRatio < 0.5 || !card.isConnected || guide.hidden) return;
            const key = card.dataset.recommendationKey;
            if (!key || recommendationViews.has(key)) return;
            recommendationViews.add(key);
            track('cc_rec_view_' + card.dataset.recommendationSlug + '_' + card.dataset.recommendationPosition);
            window.dispatchEvent(new CustomEvent('cc:recommendation-view', { detail: {
                firstColour: card.dataset.recommendationFirst,
                colour: card.dataset.recommendationSlug,
                position: Number(card.dataset.recommendationPosition),
                context: card.dataset.recommendationContext
            } }));
        });
    }, { threshold: 0.5 });
    function observeRecommendations(first) {
        recommendationObserver?.disconnect();
        guideOptions.querySelectorAll('[data-guide-pick]').forEach((card, index) => {
            if (picked[card.dataset.guidePick]) return;
            const slug = variants.get(card.dataset.guidePick).slug;
            const context = matchContext.length ? 'kurta:' + matchContext.join(',') : 'family:' + family;
            card.dataset.recommendationFirst = variants.get(first).slug;
            card.dataset.recommendationSlug = slug;
            card.dataset.recommendationPosition = String(index + 1);
            card.dataset.recommendationContext = context;
            card.dataset.recommendationKey = [first, slug, index + 1, context].join('|');
            recommendationObserver?.observe(card);
        });
    }
    function renderGuide() {
        const show = guideEligible(), count = qty(picked);
        guide.hidden = !show || guidance.dismissed;
        el('ccShowSuggestions').hidden = !show || count !== 1;
        if (!show) {
            guideKey = '';
            if (guide.contains(document.activeElement)) requestAnimationFrame(() => {
                const next = !buyBtn.hidden ? buyBtn : el('ccEditBag').hidden ? cards[0]?.querySelector('[data-select]') : el('ccEditBag');
                next?.focus({ preventScroll: true });
            });
            return;
        }
        const ids = Object.entries(picked).flatMap(([id, n]) => Array(n).fill(id));
        const first = ids[0], complete = count >= 4;
        const suggestions = wardrobeSuggestions(first);
        let options = suggestions;
        // A manually chosen extra is retained too. Never discard it to make room for an upsell.
        const outside = [...new Set(ids.slice(1))].filter(id => !options.some(v => String(v.id) === id));
        if (outside.length) {
            const chosen = outside.map(id => { const v = variants.get(id); return { ...v, styleReason: wardrobeNotes[v.slug] || '' }; });
            const selected = options.filter(v => picked[String(v.id)]);
            const remaining = options.filter(v => !picked[String(v.id)]);
            options = [...chosen, ...selected, ...remaining].slice(0, 3);
        }
        const additions = suggestions.filter(v => !picked[String(v.id)]).slice(0, Math.max(0, 4 - count));
        const key = JSON.stringify([ids, options.map(v => [v.id, v.styleReason]), available(first), family, matchContext]);
        placeGuide();
        if (guideKey !== key) {
            guideKey = key;
            const activeInside = guide.contains(document.activeElement);
            guide.dataset.stage = complete ? 'complete' : count >= 2 ? 'ready' : 'choose';
            const firstRow = el('ccGuideFirst'); firstRow.replaceChildren(); firstRow.hidden = complete;
            if (!complete) {
                const image = element('span', 'cc-guide-thumb'); image.append(guidePhoto(first));
                const label = element('span', 'cc-guide-first-label');
                label.append(element('small', '', 'Your first colour'), element('strong', '', variants.get(first).name));
                const change = element('button', 'cc-guide-change', 'Change'); change.type = 'button';
                change.dataset.guideChange = first; change.setAttribute('aria-label', 'Change first colour, ' + variants.get(first).name);
                firstRow.append(image, label, element('span', 'cc-guide-check', '✓'), change);
            }
            el('ccGuideStep').textContent = count + (count === 1 ? ' piece selected' : ' pieces selected');
            el('ccGuideTitle').textContent = complete ? 'Your 4-piece set is ready' : count >= 2 ? 'Your ' + count + ' colours are ready' : 'Build your everyday set';
            el('ccGuideIntro').textContent = complete ? money(cfg.price - cfg.perItemDisc) + ' each · Free delivery.' : count >= 2 ? 'Continue with ' + count + ', or add more at ' + money(cfg.price - cfg.perItemDisc) + ' each.' : (suggestions.length === 3 ? '3 ideas' : suggestions.length === 2 ? '2 ideas' : 'An idea') + ' for more kurtis · ' + money(cfg.price - cfg.perItemDisc) + ' each on 2+.';
            if (count === 1 && !suggestions.length) {
                const otherAvailable = cfg.variants.some(v => String(v.id) !== first && available(String(v.id)) > 0);
                el('ccGuideTitle').textContent = otherAvailable ? 'Choose another colour' : available(first) >= 2 ? 'Choose a second piece' : 'No other colours available';
                el('ccGuideIntro').textContent = otherAvailable ? 'Our suggested shades are unavailable. You can choose from the other colours below.' : available(first) >= 2 ? 'Choose the same colour again, if you like.' : 'You can order your selected colour on its own.';
            }
            guideOptions.replaceChildren();
            if (complete) {
                Object.entries(picked).forEach(([id, n]) => {
                    const v = variants.get(id), item = element('div', 'cc-guide-option');
                    const image = element('span', 'cc-guide-image'); image.append(guidePhoto(id), element('span', 'cc-guide-selected-mark', '✓'));
                    const caption = element('span', 'cc-guide-caption');
                    caption.append(element('strong', '', v.name + (n > 1 ? ' × ' + n : '')));
                    const remove = element('button', 'cc-guide-change', 'Remove'); remove.type = 'button'; remove.dataset.guideRemove = id;
                    remove.setAttribute('aria-label', 'Remove one ' + v.name + ' from selection'); caption.append(remove);
                    item.append(image, caption); guideOptions.append(item);
                });
            } else options.forEach(v => guideOptions.append(colourChoice(v)));
            guideOptions.dataset.count = String(complete ? Object.keys(picked).length : options.length);
            observeRecommendations(first);
            if (count === 1 && !suggestions.length && available(first) < 2) {
                const single = element('a', 'cc-guide-single', 'Shop ' + variants.get(first).name + ' on its own →');
                single.href = cfg.productUrl + '?variant=' + encodeURIComponent(first);
                guideOptions.append(single); guideOptions.dataset.count = '1';
            }
            el('ccGuideNote').hidden = complete || !suggestions.length;
            el('ccGuideAll').hidden = complete || additions.length < 2;
            const addLabel = count === 1 ? 'Add all ' + additions.length : 'Add remaining ' + additions.length;
            el('ccGuideAll').textContent = addLabel + ' · ' + (count + additions.length) + ' for ' + money(estimate(count + additions.length));
            el('ccGuideAllNote').hidden = el('ccGuideAll').hidden;
            el('ccGuidePayment').hidden = count < 2;
            el('ccGuideOnline').textContent = money(estimate(count));
            el('ccGuideCod').textContent = money(estimate(count) + cfg.codFee);
            el('ccGuideContinue').textContent = 'Continue with ' + count + ' pieces';
            el('ccGuideBrowse').firstChild.textContent = count >= 2 ? 'Browse more colours ' : 'See all colours ';
            el('ccGuideSame').hidden = count !== 1 || available(first) < 2;
            el('ccGuideSame').textContent = 'Or choose ' + variants.get(first).name + ' again';
            renderReview(count);
            if (activeInside && !guide.hidden) el('ccGuideTitle').focus({ preventScroll: true });
        }
        guide.querySelectorAll('button').forEach(button => { button.disabled = busy; });
        el('ccShowSuggestions').disabled = busy;
    }
    function revealGuide() {
        if (!guideEligible()) return;
        guidance.dismissed = false; renderGuide();
        const move = ++guideMove;
        requestAnimationFrame(() => {
            if (move !== guideMove || guide.hidden || !guideEligible()) return;
            el('ccGuideTitle').focus({ preventScroll: true });
            const top = guide.getBoundingClientRect().top;
            if (top < 12 || top > 64) {
                window.scrollTo({ top: Math.max(0, scrollY + top - 16), behavior: reduceMotion.matches ? 'instant' : 'smooth' });
            }
        });
        if (!guidance.exposed) { track('cc_second_view', variants.get(Object.keys(picked)[0]).slug); guidance.exposed = true; }
    }
    function browseColours(changeId) {
        if (busy || !guidance) return;
        const position = guidance.position;
        guidance.dismissed = true; guideMove++;
        applyFamily('all');
        if (changeId) setQty(changeId, Math.max(0, (picked[changeId] || 0) - 1));
        renderGuide();
        const target = cards.find(card => card.dataset.id === (changeId || position)) || cards[0];
        target?.querySelector('[data-select]')?.focus({ preventScroll: true });
        target?.scrollIntoView({ block: 'center', behavior: reduceMotion.matches ? 'instant' : 'smooth' });
        track(changeId ? 'cc_pair_edit' : 'cc_second_browse');
    }
    guide.addEventListener('click', e => {
        if (busy) return;
        const choice = e.target.closest('[data-guide-pick]');
        const change = e.target.closest('[data-guide-change]');
        const remove = e.target.closest('[data-guide-remove]');
        if (choice) {
            const id = choice.dataset.guidePick;
            if (!guideEligible() || !available(id) || qty(picked) >= 4) return;
            const adding = !picked[id];
            setQty(id, adding ? 1 : picked[id] - 1, 'suggestion'); track('cc_wardrobe_suggestion', variants.get(id).slug);
            track((adding ? 'cc_rec_add_' : 'cc_rec_remove_') + variants.get(id).slug);
        } else if (remove) { const id = remove.dataset.guideRemove; setQty(id, (picked[id] || 0) - 1);
        } else if (change) browseColours(change.dataset.guideChange);
    });
    el('ccGuideAll').addEventListener('click', () => {
        if (busy || !guideEligible() || qty(picked) >= 4) return;
        const before = qty(picked);
        const choices = wardrobeSuggestions(Object.keys(picked)[0])
            .filter(v => !picked[String(v.id)]).slice(0, 4 - before);
        if (choices.length < 2 || choices.some(v => available(String(v.id)) < 1)) return;
        choices.forEach(v => { picked[String(v.id)] = 1; track('cc_pick', v.name); track('cc_rec_add_' + v.slug); });
        render();
        if (before === 1) track('cc_pair_complete', 'add_suggestions');
        if (before < 3 && qty(picked) >= 3) track('cc_wardrobe_three', 'add_suggestions');
        if (qty(picked) === 4) track('cc_wardrobe_four', 'add_suggestions');
    });
    el('ccGuideContinue').addEventListener('click', buy);
    el('ccGuideBrowse').addEventListener('click', () => browseColours());
    el('ccGuideSame').addEventListener('click', () => {
        const id = Object.keys(picked)[0];
        if (id && qty(picked) === 1 && available(id) >= 2) { setQty(id, 2, 'same_colour'); track('cc_second_same', variants.get(id).slug); }
    });
    el('ccShowSuggestions').addEventListener('click', revealGuide);
    wideGrid.addEventListener('change', placeGuide);
    function render() {
        paint();
        document.querySelectorAll('[data-match-open]').forEach(button => { button.hidden = !matchEligible(); button.disabled = busy; });
        el('ccFamilies').querySelectorAll('button').forEach(button => { button.disabled = busy; });
        renderViewer();
        if (!matchEligible() && matcher.open) {
            closeDialog(matcher, false);
            requestAnimationFrame(() => (el('ccEditBag').hidden ? buyBtn : el('ccEditBag')).focus({ preventScroll: true }));
        }
        renderGuide();
        const count = total(), inBag = (cart?.items || []).reduce((n, i) => n + i.quantity, 0);
        const mixed = (cart?.items || []).some(i => !variants.has(String(i.variant_id || i.id)));
        bar.hidden = false; document.body.classList.add('cc-has-bar');
        el('ccEditBag').hidden = inBag === 0;
        el('ccEditBag').textContent = 'View bag · ' + inBag + (inBag === 1 ? ' piece' : ' pieces');
        el('ccSelectionHint').textContent = qty(picked) ? qty(picked) + ' selected · tap again to remove' : 'Pick a colour you like.';
        el('ccBarTitle').textContent = count === 0 ? money(cfg.price - cfg.perItemDisc) + ' each on 2+' : count === 1 ? 'Choose your second colour' : count + ' pieces · ' + money(cfg.price - cfg.perItemDisc) + ' each';
        if (count === 1 && qty(picked) === 1) el('ccBarTitle').textContent = variants.get(Object.keys(picked)[0]).name + ' selected';
        el('ccBarSub').textContent = count < 2 ? 'Any 2 · ' + money(estimate(2)) + ' online, delivered free' : 'UPI/card ' + money(estimate(count)) + ' · COD ' + money(estimate(count) + cfg.codFee);
        if (mixed) {
            el('ccBarTitle').textContent = qty(picked) ? qty(picked) + ' selected + your existing bag' : 'Your existing bag';
            el('ccBarSub').textContent = 'Review your items and total before checkout';
        } else if (!qty(picked) && inBag && cart) {
            el('ccBarTitle').textContent = inBag + ' in your bag · ' + money(cart.total_price);
            el('ccBarSub').textContent = 'Item subtotal · delivery and payment at checkout';
        }
        buyBtn.hidden = count < 2 && !mixed && !uncertain;
        buyBtn.disabled = busy;
        buyBtn.classList.toggle('is-busy', busy);
        buyBtn.textContent = busy ? 'Checking your bag…' : uncertain ? 'Review bag' : mixed ? 'Review bag' : !qty(picked) && inBag ? 'Continue with bag' : 'Continue · ' + money(estimate(count));
        el('ccBagCheckout').disabled = busy;
    }
    function setQty(id, amount, source = 'catalogue') {
        if (busy) return;
        const v = variants.get(id);
        if (!v) return;
        if (!v.available && amount > 0) {
            el('ccSheetText').textContent = v.name + ' is out of stock right now.';
            el('ccSheetWa').href = 'https://wa.me/' + cfg.wa + '?text=' + encodeURIComponent('Hi! Please tell me when ' + v.name + ' Cotton Salwar Pant is back in stock.');
            openDialog(sheet); track('cc_oos', v.name); return;
        }
        const next = Math.max(0, Math.min(available(id), amount));
        const before = total();
        feedback(amount > next ? 'You have selected all available ' + v.name + ' pieces. Choose another colour to complete your set.' : '');
        if (next) picked[id] = next; else delete picked[id];
        const openGuide = cfg.guidedSecond !== false && before === 0 && total() === 1 && !uncertain && !cart?.items.length;
        if (openGuide) guidance = { position: id, dismissed: false, exposed: false };
        if (!qty(picked)) { guidance = null; matchContext = []; guideMove++; }
        render(); track(next ? 'cc_pick' : 'cc_unpick', v.name);
        if (before === 1 && total() === 2) track('cc_pair_complete', source);
        if (before < 3 && total() === 3) track('cc_wardrobe_three', source);
        if (before < 4 && total() === 4) track('cc_wardrobe_four', source);
        if (openGuide) revealGuide();
    }
    function openDialog(dialog, trigger = document.activeElement) {
        dialogTriggers.set(dialog, trigger);
        dialog.showModal(); document.body.style.overflow = 'hidden';
    }
    function closeDialog(dialog, restore = true) {
        if (!restore) skipDialogReturn.add(dialog);
        dialog.close();
    }
    [details, sheet, bag, viewer, matcher, reviewDialog].forEach(dialog => {
        dialog.addEventListener('close', () => {
            const another = [details, sheet, bag, viewer, matcher, reviewDialog].some(item => item.open);
            if (!another) document.body.style.overflow = '';
            if (!skipDialogReturn.has(dialog) && !another) dialogTriggers.get(dialog)?.focus({ preventScroll: true });
            skipDialogReturn.delete(dialog);
        });
        dialog.addEventListener('click', e => { if (e.target === dialog) closeDialog(dialog); });
    });
    reviewDialog.addEventListener('close', () => {
        if (!reviewScroll) return;
        const saved = reviewScroll; reviewScroll = null;
        Object.assign(document.body.style, saved.styles, { overflow: saved.overflow });
        document.documentElement.style.overflow = saved.rootOverflow;
        window.scrollTo({ left: saved.x, top: saved.y, behavior: 'instant' });
    });
    document.addEventListener('click', e => {
        const detailButton = e.target.closest('[data-details]');
        if (detailButton) {
            const replacement = detailButton.dataset.details === 'replacement';
            el('ccDetailsTitle').textContent = replacement ? 'Replacement policy' : 'Size & fit';
            el('ccDetailsBody').innerHTML = el(replacement ? 'ccReplacementSpecs' : 'ccFitSpecs').innerHTML;
            openDialog(details);
            track('cc_details');
        }
        if (e.target.closest('[data-details-close]')) closeDialog(details);
        if (e.target.closest('[data-sheet-close]')) closeDialog(sheet);
        if (e.target.closest('[data-bag-close]')) closeDialog(bag);
        if (e.target.closest('[data-viewer-close]')) closeDialog(viewer);
        if (e.target.closest('[data-review-close]')) closeDialog(reviewDialog);
        if (e.target.closest('[data-matcher-close]')) closeDialog(matcher);
        if (e.target.closest('[data-match-open]')) openMatcher();
    });
    grid.addEventListener('click', e => {
        const card = e.target.closest('.cc-card[data-id]');
        if (!card || busy) return;
        const id = card.dataset.id;
        if (e.target.closest('[data-zoom]')) { openViewer(id, e.target.closest('[data-zoom]')); return; }
        if (e.target.closest('[data-inc]')) setQty(id, (picked[id] || 0) + 1);
        else if (e.target.closest('[data-dec]')) setQty(id, (picked[id] || 0) - 1);
        else setQty(id, picked[id] ? 0 : 1);
    });
    async function request(path, body) {
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), 12000);
        try {
            const response = await fetch(root + path, {
                method: body ? 'POST' : 'GET', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
                credentials: 'same-origin', cache: 'no-store', signal: controller.signal,
                ...(body ? { body: JSON.stringify(body) } : {})
            });
            const data = await response.json();
            if (!response.ok) { const error = new Error(data.description || data.message || 'Unable to update your bag.'); error.status = response.status; throw error; }
            return data;
        } finally { clearTimeout(timer); }
    }
    async function readCart() {
        const next = await request('cart.js');
        if (!Array.isArray(next.items) || !Number.isFinite(next.total_price)) throw new Error('Unable to read your bag.');
        return next;
    }
    function sameCounts(a, b) {
        const keys = new Set([...Object.keys(a), ...Object.keys(b)]);
        return [...keys].every(id => (a[id] || 0) === (b[id] || 0));
    }
    function showBag(message) {
        el('ccBagMessage').textContent = message || 'Check your colours and quantities before continuing.';
        el('ccBagItems').replaceChildren();
        (cart?.items || []).forEach(item => {
            const li = document.createElement('li');
            const name = document.createElement('span'); name.textContent = (item.variant_title || item.product_title || item.title) + ' × ' + item.quantity;
            const amount = document.createElement('strong'); amount.textContent = money(item.final_line_price);
            li.append(name, amount); el('ccBagItems').append(li);
        });
        el('ccBagTotal').textContent = 'Item subtotal · ' + money(cart?.total_price || 0);
        el('ccBagNote').textContent = 'Delivery and any COD charge are shown at checkout.' + (qty(picked) ? ' Your unadded selections remain on the colours page.' : '');
        el('ccBagCheckout').hidden = !cart?.items.length;
        if (!bag.open) openDialog(bag);
    }
    async function reviewBag() {
        if (busy) return;
        busy = true; render();
        try {
            cart = await readCart();
            if (uncertain) { picked = {}; pending(false); }
            showBag();
        } catch (_) {
            feedback('We could not load your bag. Open your bag to check it before trying again.');
            window.location.href = root + 'cart';
        } finally { busy = false; render(); }
    }
    async function buy() {
        if (busy) return;
        if (uncertain) return reviewBag();
        if (total() < 2 && !cart?.items.length) return;
        busy = true; render(); feedback('');
        let before, attempted = false;
        const selection = { ...picked };
        try {
            before = await readCart();
            if (cart && signature(before) !== signature(cart)) {
                cart = before; showBag('Your bag has changed. Review it before adding more colours.'); return;
            }
            cart = before;
            if (!qty(selection)) {
                if (before.items.length) window.location.href = root + 'checkout';
                else feedback('Your bag is empty. Choose your colours to begin.', true);
                return;
            }
            if (Object.entries(selection).some(([id, count]) => count > available(id))) {
                feedback('The available quantity has changed. Adjust your selection or review your existing bag.', true); return;
            }
            const expected = { ...cartCounts(before) };
            Object.entries(selection).forEach(([id, count]) => { expected[id] = (expected[id] || 0) + count; });
            pending(true); attempted = true;
            let addError;
            try { await request('cart/add.js', { items: Object.entries(selection).map(([id, quantity]) => ({ id: Number(id), quantity })) }); }
            catch (error) { addError = error; }
            const after = await readCart();
            const actual = cartCounts(after), initial = cartCounts(before);
            Object.entries(selection).forEach(([id, count]) => {
                const remaining = count - Math.max(0, (actual[id] || 0) - (initial[id] || 0));
                if (remaining > 0) picked[id] = remaining; else delete picked[id];
            });
            cart = after;
            if (addError && (!addError.status || addError.status >= 500)) {
                picked = {};
                pending(true);
            } else pending(false);
            const onlyCatalogue = after.items.every(i => variants.has(String(i.variant_id || i.id)));
            const count = catalogueQty(after);
            const expectedSubtotal = count * (cfg.price - (count >= 2 ? cfg.perItemDisc : 0));
            if (addError || !sameCounts(expected, actual) || !onlyCatalogue || after.total_price !== expectedSubtotal || (after.currency && after.currency !== 'INR')) {
                const message = addError?.status === 422
                    ? 'Some selected quantities are unavailable. Check what is in your bag; the unadded colours remain selected on the page.'
                    : addError ? 'The connection was interrupted. We checked your bag; review the items before continuing.'
                    : 'Your basket or price has changed. Review the confirmed items and subtotal before continuing.';
                showBag(message); track('cc_cart_review'); return;
            }
            track('cc_checkout', count);
            window.location.href = root + 'checkout';
        } catch (_) {
            if (attempted) {
                pending(true);
                feedback('We could not confirm whether your colours were added. Review your bag before trying again, so nothing is added twice.', true);
            } else feedback('We could not connect to your bag. Please try again. Your selection is still here.', true);
        } finally { busy = false; render(); }
    }
    buyBtn.addEventListener('click', buy);
    el('ccEditBag').addEventListener('click', reviewBag);
    el('ccBagCheckout').addEventListener('click', async () => {
        if (busy) return;
        busy = true; render();
        try {
            const latest = await readCart();
            if (signature(latest) !== signature(cart)) { cart = latest; showBag('Your bag changed. Please review the updated items and subtotal.'); }
            else if (latest.items.length) window.location.href = root + 'checkout';
        } catch (_) { el('ccBagMessage').textContent = 'We could not verify your bag. Please try again.'; }
        finally { busy = false; render(); }
    });
    cards.forEach(card => {
        const label = card.querySelector('.cc-family-label');
        const look = colourLooks[card.dataset.slug];
        label.textContent = look?.[0] || ''; label.hidden = !look;
        card.querySelector('[data-zoom]').hidden = false;
    });
    el('ccFamilies').hidden = cfg.colourFamilies === false;
    Object.entries(kurtaColours).forEach(([key, info]) => {
        const button = element('button', 'cc-kurta-choice');
        button.type = 'button'; button.dataset.kurta = key; button.setAttribute('aria-pressed', 'false');
        const swatch = element('span', 'cc-kurta-swatch'); swatch.style.background = info.colour; swatch.setAttribute('aria-hidden', 'true');
        button.append(swatch, element('span', '', info.label)); el('ccKurtaChoices').append(button);
    });
    const params = new URLSearchParams(location.search);
    if (!hadPendingAdd) (params.get('pick') || '').split(',').forEach(slug => {
        const v = cfg.variants.find(v => v.slug === slug);
        if (v && available(String(v.id)) > 0) picked[String(v.id)] = 1;
    });
    const linked = cfg.variants.find(v => v.slug === params.get('c') || String(v.id) === params.get('variant'));
    if (linked && !qty(picked)) {
        const index = cards.findIndex(card => card.dataset.id === String(linked.id));
        const card = cards.splice(index, 1)[0];
        cards.unshift(card); grid.prepend(card);
        card.querySelector('img').loading = 'eager'; card.querySelector('img').fetchPriority = 'high';
    }
    el('ccSingleLink').addEventListener('click', () => {
        const id = Object.keys(picked)[0];
        if (id) el('ccSingleLink').href = cfg.productUrl + '?variant=' + encodeURIComponent(id);
        track('cc_single_option');
    });
    render();
    readCart().then(value => {
        if (busy) return;
        cart = value;
        if (hadPendingAdd) { picked = {}; pending(false); showBag('Check your bag after your previous visit before adding any more colours.'); }
        if (!guidance && !hadPendingAdd && !cart.items.length && qty(picked) === 1 && cfg.guidedSecond !== false) {
            guidance = { position: Object.keys(picked)[0], dismissed: false, exposed: false };
            render(); revealGuide(); return;
        }
        render();
    }).catch(() => { feedback('Your selection is ready. We will check your bag when you continue.'); });
})();
